export const COLORS = {
  primary: {
    main: '#F4A900',
    hover: '#F48400',
  },
  secondary: {
    main: '#1FC9FF',
  },
  error: '#EB5757',
  danger: '#CC0000',
  success: '#04844B',
  grayScale: ['#000000', '#111111', '#1F1F1E', '#1F1F1F', '#444444', '#FFFFFF'],
};
